/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dropvalidationdrawafterstart4Inputs */

const en_dropvalidationdrawafterstart4 = /** @type {(inputs: Dropvalidationdrawafterstart4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Draw time must be after the start time`)
};

const de_dropvalidationdrawafterstart4 = /** @type {(inputs: Dropvalidationdrawafterstart4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Der Ziehungszeitpunkt muss nach dem Start liegen`)
};

/**
* | output |
* | --- |
* | "Draw time must be after the start time" |
*
* @param {Dropvalidationdrawafterstart4Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const dropvalidationdrawafterstart4 = /** @type {((inputs?: Dropvalidationdrawafterstart4Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dropvalidationdrawafterstart4Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_dropvalidationdrawafterstart4(inputs)
	return de_dropvalidationdrawafterstart4(inputs)
});
export { dropvalidationdrawafterstart4 as "dropValidationDrawAfterStart" }